module.exports = __webpack_public_path__ + "static/img/n1.78aa032.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/resourceShow/img/zh/n1.png
// module id = iO8T
// module chunks = 3